import styled from 'styled-components';
import { BREAKPOINTS } from '../styles';

const AuthPageSection = styled.section`
  display: flex;
  flex: 1;
  flex-direction: column;

  ${BREAKPOINTS.MEDIUM} {
    padding: 24px;
    width: calc(50% - 48px);
  }
`;

export default AuthPageSection;
